import React from "react";
import BackButton from "../../main/BackButton";
import Video from "../../main/Video";

const Collection8Video = () => {
  return (
    <>
      <BackButton url="/allvideos" />
      <Video
        url={`https://yuriy-dmytrash19.wistia.com/medias/iox4tiamjn`}
        maxHeight="80%"
      />
    </>
  );
};

export default Collection8Video;
